import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import Subheader from 'components/atoms/GefMui/Subheader';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { previous as setPreviousContextUser } from 'features/views/userContext/actions';
import { getContextUser } from 'features/views/userContext/selectors';

import ActionButtons from './ActionButtons';

export const Toolbar = ({ setResettingSubordinateUsersOnly }) => {
	const dispatch = useDispatch();

	const contextUser = useSelector(getContextUser);
	const customHandleBack = useCallback(() => {
		dispatch(setPreviousContextUser());
		setResettingSubordinateUsersOnly(true);
	}, [dispatch, setResettingSubordinateUsersOnly]);

	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('subordinateUsers:pageTitle'),
		onBack: customHandleBack,
	});

	return <ToolbarTemplate leftSide={<Subheader title={subheaderTitle} />} rightSide={<ActionButtons />} />;
};

Toolbar.propTypes = {
	setResettingSubordinateUsersOnly: PropTypes.func,
};

export default Toolbar;
